import React from 'react';
import './Courses.css';
import CourseCard from '../../components/Courses/CourseCard';
import courseData from '../../data/courses';

const CoursesPage = () => {
  return (
    <main className="courses-page">
      {/* Hero Section */}
      <section className="courses-hero">
        <div className="container">
          <h1>Our Training Programs</h1>
          <p>Choose the right path for your healthcare career</p>
        </div>
      </section>

      {/* All Courses */}
      <section className="all-courses">
        <div className="container">
          <div className="courses-filter">
            <button className="filter-btn active">All Programs</button>
            <button className="filter-btn">Certification</button>
            <button className="filter-btn">Continuing Education</button>
            <button className="filter-btn">Specialty Training</button>
          </div>

          <div className="courses-grid">
            {courseData.map(course => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="courses-cta">
        <div className="container">
          <h2>Not sure which program is right for you?</h2>
          <p>Our advisors can help you choose the best path for your career goals</p>
          <a href="/contact" className="cta-btn">Schedule a Consultation</a>
        </div>
      </section>
    </main>
  );
};

export default CoursesPage;